import { useQuery } from '@tanstack/react-query'
import { systemSettingsApi } from '@/api/endpoints'
import { queryKeys, queryOptions } from '@/config/queryConfig'
import type { DefaultEventCategory } from '@/types'

/** #248 — the tab the Events page opens on: one fleet-wide value a super admin chooses, the
 * same for every user. `category` is undefined while loading (the page must not mount the
 * feed before it is known — the URL hook canonicalises on mount against the schema default)
 * and `all` if the request fails, so a flaky setting never blocks the page. */
export function useDefaultEventCategory(): {
  category: DefaultEventCategory | undefined
  isLoading: boolean
} {
  const { data, isError, isLoading } = useQuery({
    queryKey: queryKeys.systemSettings.defaultEventsView(),
    queryFn: systemSettingsApi.getGlobalDefaultEventsView,
    ...queryOptions.systemSettings.defaultEventsView,
  })
  return { category: data?.category ?? (isError ? 'all' : undefined), isLoading }
}
